module.exports = {
      id: "triangle-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.91580017.svg#triangle-usage",
      toString: function () {
        return this.url;
      }
    }